export default __webpack_public_path__ + "static/media/app6.897e3a2f.png";